import React from 'react';
import './StatusBadge.css';

const StatusBadge = ({
  status = 'default',
  variant = 'filled',
  size = 'md',
  children,
  className = '',
  ...props
}) => {
  const badgeClasses = [
    'status-badge',
    `status-badge--${status}`,
    `status-badge--${variant}`,
    `status-badge--${size}`,
    className
  ].filter(Boolean).join(' ');

  return (
    <span className={badgeClasses} {...props}>
      {children}
    </span>
  );
};

export default StatusBadge;